// The "Új márka létrehozása" onboarding (POST /brands, no Shopify) and the
// manual product upload (POST /brands/:id/products/manual): the partner terms
// the brand accepts, and the image rules the API enforces (the same for the
// logo, the cover and product photos).

/// The B2B partner terms (ÁSZF) on the landing site: the HU / EN PDF
/// (outfino_tos_b2b_hu.pdf / _en.pdf) behind /terms-b2b.
export const PARTNER_TERMS_URL = 'https://outfino.io/terms-b2b';

/// Sent as `termsVersion` and stored with the acceptance (1–32 of
/// [A-Za-z0-9._-]). Bump it whenever the partner terms change.
export const PARTNER_TERMS_VERSION = '2026-08';

/// JPEG, PNG or WebP (the API reads the type from the bytes).
export const BRAND_IMAGE_TYPES = ['image/jpeg', 'image/png', 'image/webp'];
export const BRAND_IMAGE_ACCEPT = BRAND_IMAGE_TYPES.join(',');

/// At most 10 MB per file (the API's default BRAND_IMAGE_MAX_BYTES).
export const BRAND_IMAGE_MAX_BYTES = 10 * 1024 * 1024;

/// Manual product photos: 1–8, the first one is the main photo.
export const PRODUCT_IMAGES_MAX = 8;

/// The currencies offered for a manual product (any ISO 4217 code works on
/// the API side).
export const PRODUCT_CURRENCIES = ['HUF', 'EUR', 'USD', 'GBP', 'CZK', 'PLN', 'RON', 'CHF'];
